import { render, staticRenderFns } from "./AutomationStatsModal.vue?vue&type=template&id=637b6daa&scoped=true&"
import script from "./AutomationStatsModal.vue?vue&type=script&lang=ts&"
export * from "./AutomationStatsModal.vue?vue&type=script&lang=ts&"
import style0 from "./AutomationStatsModal.vue?vue&type=style&index=0&id=637b6daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637b6daa",
  null
  
)

export default component.exports